import { IMAGE_URL } from "../../../../Utilities/APIs/APIs";

function Image({ imgLink, imgAlt, name = '' }) {
  // Function to get initials from name
  const getInitials = (fullName) => {
    if (!fullName) return '';
    const words = fullName.trim().split(' ');
    if (words.length === 1) return words[0][0].toUpperCase();           // "Sakib" -> "S"
    if (words.length === 2) return (words[0][0] + words[1][0]).toUpperCase(); // "Sakib Khan" -> "SK"
    return words.slice(0, 3).map(word => word[0]).join('').toUpperCase(); // "Sakib Rakib Jakib" -> "SRJ"
  };

  const initials = getInitials(name);

  if (imgLink) {
    return (
      <img
        src={IMAGE_URL + imgLink}
        alt={imgAlt || name}
        style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }}
      />
    );
  }

  // fallback avatar
  return (
    <div
      style={{
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
        fontSize: '14px',
        color: '#000', // you can customize
        border: '1px solid #ccc',
        textTransform: 'uppercase',
      }}
      title={name}
    >
      {initials}
    </div>
  );
}

export default Image;
